export default [
    {
        path: '/user-performance',
        name: 'indexUserPerformance',
        meta: { title: 'indexUserPerformance' },
        component: () => import('@/pages/admin/user-performance/index.vue'),
    },
    {
        path: "/user-performance/create",
        name: "createUserPerformance",
        meta: { title: 'createUserPerformance' },
        component: () => import('@/pages/admin/user-performance/create.vue'),
    },
    {
        path: "/user-performance/:id/edit",
        name: "editUserPerformance",
        meta: { title: 'editUserPerformance' },
        component: () => import('@/pages/admin/user-performance/edit.vue'),
    },
]